import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSnowLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Snow",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.17084 2.46967C9.46373 2.17678 9.93861 2.17678 10.2315 2.46967L12.0206 4.25873L13.7874 2.4919C14.0803 2.199 14.5552 2.199 14.8481 2.4919C15.141 2.78479 15.141 3.25966 14.8481 3.55256L12.5509 5.84972C12.4102 5.99038 12.2195 6.06939 12.0206 6.06939C11.8217 6.06939 11.6309 5.99038 11.4902 5.84972L9.17084 3.53033C8.87795 3.23744 8.87795 2.76256 9.17084 2.46967Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.4903 18.1523C11.7832 17.8596 12.2579 17.8596 12.5508 18.1523L14.8479 20.4485C15.1409 20.7413 15.141 21.2162 14.8482 21.5092C14.5553 21.8021 14.0805 21.8022 13.7875 21.5094L12.0206 19.7432L10.2314 21.5316C9.93844 21.8244 9.46356 21.8243 9.17073 21.5314C8.8779 21.2384 8.878 20.7636 9.17095 20.4707L11.4903 18.1523Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.0098 4.57019C12.424 4.57019 12.7598 4.90598 12.7598 5.32019V18.6751C12.7598 19.0893 12.424 19.4251 12.0098 19.4251C11.5956 19.4251 11.2598 19.0893 11.2598 18.6751V5.32019C11.2598 4.90598 11.5956 4.57019 12.0098 4.57019Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.8465 4.77419C19.2465 4.88147 19.4839 5.29277 19.3766 5.69285L18.7214 8.1362L21.1348 8.78284C21.5349 8.89004 21.7723 9.30129 21.6651 9.70139C21.5579 10.1015 21.1467 10.3389 20.7466 10.2317L17.6086 9.39095C17.4165 9.33946 17.2526 9.21374 17.1532 9.04145C17.0537 8.86915 17.0268 8.6644 17.0783 8.47225L17.9278 5.30435C18.0351 4.90427 18.4464 4.66691 18.8465 4.77419Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.33601 14.3101C2.44315 13.91 2.85436 13.6725 3.25448 13.7796L6.42335 14.6281C6.61551 14.6796 6.77936 14.8053 6.87884 14.9775C6.97833 15.1498 7.00529 15.3546 6.95381 15.5467L6.11303 18.6847C6.00582 19.0848 5.59457 19.3222 5.19447 19.215C4.79437 19.1078 4.55693 18.6965 4.66413 18.2964L5.31077 15.8831L2.8665 15.2286C2.46638 15.1214 2.22887 14.7102 2.33601 14.3101Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.4432 8.28586C18.6503 8.64457 18.5275 9.10327 18.1687 9.31039L6.60368 15.9883C6.24497 16.1954 5.78627 16.0726 5.57914 15.7138C5.37202 15.3551 5.4949 14.8964 5.85361 14.6893L17.4187 8.01139C17.7774 7.80427 18.2361 7.92715 18.4432 8.28586Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.6651 14.2865C21.7723 14.6866 21.5349 15.0979 21.1348 15.2051L18.7214 15.8517L19.3766 18.2951C19.4839 18.6952 19.2465 19.1065 18.8465 19.2137C18.4464 19.321 18.0351 19.0837 17.9278 18.6836L17.0783 15.5157C17.0268 15.3235 17.0537 15.1188 17.1532 14.9465C17.2526 14.7742 17.4165 14.6485 17.6086 14.597L20.7466 13.7562C21.1467 13.649 21.5579 13.8864 21.6651 14.2865Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.19447 4.77428C5.59457 4.66707 6.00582 4.90451 6.11303 5.30461L6.95381 8.44256C7.00529 8.63471 6.97833 8.83945 6.87884 9.01173C6.77936 9.184 6.61551 9.30969 6.42335 9.36114L3.25448 10.2097C2.85436 10.3168 2.44315 10.0793 2.33601 9.67917C2.22887 9.27905 2.46638 8.86784 2.8665 8.7607L5.31077 8.10621L4.66413 5.69283C4.55693 5.29273 4.79437 4.88148 5.19447 4.77428Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.57914 8.27414C5.78627 7.91543 6.24497 7.79255 6.60368 7.99967L18.1687 14.6776C18.5275 14.8847 18.6503 15.3434 18.4432 15.7021C18.2361 16.0608 17.7774 16.1837 17.4187 15.9766L5.85361 9.29867C5.4949 9.09155 5.37202 8.63285 5.57914 8.27414Z",
			fill: "currentColor"
		})
	]
});
export default SvgSnowLine;
